import * as React from 'react';
export const IframeComponent = (props) => {
    const wrapperStyle = {
        textAlign: props.value.align || 'center'
    };
    const iframeStyle = {
        height: props.value.height || 400
    };
    return (React.createElement("div", { className: 'component iframe-component', "data-component-type": 'iframe' },
        React.createElement("div", { className: 'iframe-wrapper', style: wrapperStyle },
            React.createElement("iframe", { src: props.value.url, style: iframeStyle, scrolling: props.value.scrolling || 'auto' }))));
};
